import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import {
  finalize,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
} from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { AccountService } from 'src/app/services/user/account.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'app-select-country-modal',
  templateUrl: './select-country-modal.component.html',
  styleUrls: ['./select-country-modal.component.scss'],
})
export class SelectCountryModalComponent implements OnInit, OnDestroy {
  @ViewChild('countrySearch', { static: false }) searchbar: IonSearchbar;
  public suggestionList: any[];
  public currentHeaderData: any = {
    modalSlotEnd: true,
    marl20: true,
    title: 'hotel.select_country_modal.header',
  };

  page: number;
  noData: boolean;
  loading: boolean;
  searchTerm: string;
  lastPage: boolean;
  private searchSubject = new Subject<string>();
  private searchSubscription: Subscription;

  constructor(
    private modalController: ModalController,
    private accountService: AccountService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.initPageState();
    this.getAutoSuggestions();

    this.searchSubscription = this.searchSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        map((term: string) => term.trim()),
        switchMap((searchTerm: string) => {
          this.searchTerm = searchTerm;
          this.noData = false;
          this.page = 0;
          this.lastPage = false;
          this.loading = true;

          return this.accountService
            .getCountries(this.searchTerm, this.page)
            .pipe(finalize(() => (this.loading = false)));
        })
      )
      .subscribe((response) => {
        if (response?.last) {
          this.lastPage = true;
        }
        if (response?.content?.length > 0) {
          this.suggestionList = response.content;
        } else {
          this.noData = true;
        }
      },
      (error) => {
        this.analyticsService.trackResponseError(error, 'Country Selection Error');
      }
    );
  }

  initPageState() {
    this.suggestionList = [];
    this.page = 0;
    this.noData = false;
    this.loading = false;
    this.lastPage = false;
    this.searchTerm = '';
  }
  selectSuggestion(item) {
    this.modalController.dismiss({
      ...item,
    });
  }
  closeModal() {
    this.analyticsService.trackUnified('country_selection_modal_closed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Country Selection Close',
      button: 'country-selection-close',
    });
    this.modalController.dismiss();
  }
  async getAutoSuggestions() {
    this.noData = false;
    this.page = 0;
    this.lastPage = false;
    this.loading = true;
    this.accountService
      .getCountries(this.searchTerm, this.page)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response) => {
        if (response?.last) {
          this.lastPage = true;
        }
        if (response?.content?.length > 0) {
          this.suggestionList = response.content;
        } else {
          this.noData = true;
        }
      },
      (error) => {
        this.analyticsService.trackResponseError(error, 'Country Selection Error');
      }
    );
  }

  getNextPage(event) {
    this.page++;
    this.accountService
      .getCountries(this.searchTerm, this.page)
      .pipe(
        finalize(() => {
          event.target.complete();
        })
      )
      .subscribe((response) => {
        if (response?.last) {
          event.target.disabled = true;
        }
        if (response?.content?.length > 0) {
          this.suggestionList = this.suggestionList.concat(response.content);
        }
      });
  }

  filterLIst(event) {
    const searchTerm = event.srcElement.value;
    this.searchSubject.next(searchTerm);
  }

  filterListOnEnter(event) {
    const searchTerm = event.srcElement.value;
    this.searchSubject.next(searchTerm);
  }

  ngOnDestroy() {
    this.searchSubscription?.unsubscribe();
    this.searchSubject.complete();
  }

  ionViewDidEnter(): void {
    try {
      this.searchbar?.setFocus();
    } catch (e) {}
  }
}
